export function creatorPlaytestReport(step) {
  if (step.step_type !== 'playtest') throw new Error(`Expected playtest step: ${step.id}`)
  if (step.output === null) return null
  if (step.output.failure !== undefined) {
    if (step.output.failure === null || typeof step.output.failure !== 'object' || Array.isArray(step.output.failure)) {
      throw new Error(`Invalid creator failure envelope: ${step.id}`)
    }
    if (step.output.failure.schema !== 'visual-game-ugc-failure/v1') {
      throw new Error(`Invalid creator failure envelope: ${step.id}`)
    }
    if (step.output.detail === null) return null
    return playtestDetailReport(step.output.detail, step.id)
  }
  return playtestDetailReport(step.output, step.id)
}

function playtestDetailReport(value, stepId) {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) throw new Error(`Invalid playtest detail: ${stepId}`)
  if (Object.hasOwn(value, 'endings')) return requirePlaytestReport(value, stepId)
  if (Object.hasOwn(value, 'canonical_report')) {
    requireObject(value.canonical_report, `Invalid canonical route report: ${stepId}`)
    return null
  }
  if (Object.hasOwn(value, 'missing_case_ids')) {
    if (!Array.isArray(value.missing_case_ids)) throw new Error(`Invalid missing playtest cases: ${stepId}`)
    return null
  }
  throw new Error(`Unhandled playtest detail variant: ${stepId}`)
}

function requirePlaytestReport(value, stepId) {
  requireObject(value, `Invalid playtest report: ${stepId}`)
  if (typeof value.passed !== 'boolean') throw new Error(`Invalid playtest report passed: ${stepId}`)
  if (!Array.isArray(value.endings) || value.endings.length === 0) throw new Error(`Invalid playtest report endings: ${stepId}`)
  for (const [index, ending] of value.endings.entries()) {
    requireObject(ending, `Invalid playtest report ending: ${stepId}, index=${index}`)
    if (typeof ending.ending_id !== 'string' || ending.ending_id.length === 0 || typeof ending.triggered !== 'boolean') {
      throw new Error(`Invalid playtest report ending fields: ${stepId}, index=${index}`)
    }
  }
  return value
}

function requireObject(value, message) {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) throw new Error(message)
  return value
}
